exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.tile{display:flex;justify-content:center;align-items:center;margin:5pt;padding:5pt 10pt;background:#8f9091}.queue-contener{display:inline-block}div.text.tile{background:none;color:#000}div.category.tile{height:auto;background:#003767}div.name.tile{min-height:60pt;background:#003767}div.state.tile{height:45pt}div.state.tile.ACTIVE{display:none}div.state.tile.INACTIVE{background:#e9494f}div.state.tile.BREAK{background:#f5a547}div.registration.tile{height:45pt}div.registration.tile.WAITING{background:#8f9091}div.registration.tile.PROCESSING{background:#003767}p{text-align:center;vertical-align:middle;color:#fff;margin:0}p.black{color:#000}p.title{size:12pt;font-weight:700;text-transform:uppercase}p.label{font-weight:700;size:10pt}p.comment{size:6pt}.menu{padding:10px}.stretched-container{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main/webapp/app/components/faculty-queues/faculty-queues.component.css
// module id = 307
// module chunks = 0